import React from 'react'
import { useEffect,useState } from 'react';
import { useNavigate } from 'react-router';
import PageTopbar from '../../../components/forms/pagetopbar'
import ApiUrl from '../../../configTools/apiUrl';
import FormError from '../../../components/forms/formError';
import Input from '../../../components/forms/inputPrimary';
import {ReactComponent as EyeImage} from '../../../images/icons/view.svg'
import '../../../css/public/register.css'
import PageNav from './pageNav';
import PrimarySelect from '../../../components/forms/primarySelect';
import PrimaryScrollSelector from '../../../components/forms/primaryScrollSelector';
import { useGoogleLogin } from '@react-oauth/google'
import { ReactComponent as ProfileIcon} from '../../../images/icons/googleColor.svg'
import Facebook from '../login/facebook';
import DocumentMeta from 'react-document-meta';
import BlackButton from '../../../components/forms/blackfillButton';

const Index = () => {
    const meta = {
      /*title: 'New Arrivals | Latest & trendy Products on KAAY',
      description: "Discover the latest products from various Brands, local vendors & artists in our New Arrivals section. From clothing, accessories, handmade crafts to unique gifts, there's something for everyone in our constantly updated selection. Our social commerce platform makes it easy for sellers to showcase their products & reach a wider audience.",
      */
      canonical: window.location.href
      /*canonical: 'http://example.com/path/to/page',
      meta: {
          charset: 'utf-8',
          name: {
              keywords: 'react,meta,document,html,tags'
          }
      }*/
    }
    const navigate = useNavigate();

    const [page, setPage] = useState(0)
    const [error,setError] = useState('');
    const [firstname, setFirstname] = useState('')
    const [lastname, setLastname] = useState('')
    const [email, setEmail] = useState('')
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [role,setRole] = useState({name:'Select', value:'0'});
    const [contact, setContact] = useState('')
    const [contactcodesent, setContactCodeSent] = useState(false);
    const [contactcode, setContactCode] = useState("");
    const [passShow, setPassShow] = useState(false);
    
    async function codesend(){
        if(contact === ""){
            alert('Enter Phone Number');
            return;
        }
        setContactCodeSent(true);
        let res = await fetch(ApiUrl.API_URL_MobileVerification+'/sendcode', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              phone: contact
            })
        })
        res = await res.json();
        if(res.success){
            setContactCodeSent(true);
        }
        else{
            setContactCodeSent(false);
            setError(res.responce);
        }
    }

    async function verifycode(){
        if(contact === "" || contactcode === ""){
            alert('Missing Phone Number Or Code');
            return;
        }
        let res = await fetch(ApiUrl.API_URL_MobileVerification+'/verifycode', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              phone: contact,
              token: contactcode
            })
        })
        res = await res.json();
        if(res.success){
            add_admin(1);
        }
        else{
            setError(res.responce);
        }
    }

    
    const setPageCheck = (e) =>{
        setError('');
        if(e === 2){
          if(firstname === "" || lastname === "" || email === "" || username === "" || password === ""){
            setError("Fields Empty");
            return;
          }
        }
        setPage(e);
    }
    
    async function add_admin(contactverified){
        let res = await fetch(ApiUrl.API_URL_OAuth+'/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              username : username,
              password : password,
              email : email,
              role : role,
              firstname : firstname,
              lastname : lastname,
              location : 1,
              contact : contactverified === 1 ? contact : "",
              address : "",
              cnic : "",
              getupdates : 1,
              intrusts : [],
              phoneverified: contactverified
            })
        })
        res = await res.json();
        if(res.success){
          navigate('/login');
        }
        else{
            setError(res.responce);
        }
    }

    const googleCallBack = useGoogleLogin({
        clientId: window.location.hostname === 'localhost'? '1004160975061-b6j28jthhreag81qdbrtn6fpm7bc38d9.apps.googleusercontent.com' :'276540982595-5neo5h285l4c5gngd2himi24c1j35lce.apps.googleusercontent.com',
        onSuccess: async responce =>  {
            console.log(responce);
            if(responce.access_token){
                let res = await fetch(ApiUrl.API_URL_OAuth+"/google", {//"http://localhost:5157/api/oauth/google",{//ApiUrl.API_URL_OAuth+"/google", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        token: responce.access_token
                    })
                })
                res = await res.json();
                console.log(res)
                if(res.success){
                    localStorage.setItem("user-info",JSON.stringify(res.responce));
                    document.location.replace('/login');
                }
            }
        }
    });
  return (
    <div className='product_create_wrapper'>
    <DocumentMeta {...meta} />
        <div className='product_create_container' style={{width:"40%"}}>
            <PageTopbar page={page} total={2} />
            <div className='product_create_form_container'>
                <div className='product_create_form_title'>
                    <h3>
                        {page === 0 && "Select Signup Role"}
                        {page === 1 && "Get ready"}
                        {page === 2 && "Phone Verification"}
                    </h3>
                    <FormError Value={error}/>
                    {page === 0 &&
                        <>
                            <div className='form_portion'>
                                <div className='form_selection' onClick={()=>{
                                    setRole("individual");
                                    setPage(1);
                                }}>
                                    <p>User Account</p>
                                </div>
                                <div className='form_selection' onClick={()=>{
                                    setRole("business");
                                    setPage(1);
                                }}>
                                    <p>Business</p>
                                </div>
                                {/*<div className='form_selection' onClick={()=>{
                                    setRole("wholesale");
                                    setPage(1);
                                }}>
                                    <p>Wholesale</p>
                            </div>*/}
                            </div>
                        </>
                    }
                    {page === 1 &&
                        <div className='register_form'>
                            <p>Enter a few details to join the Kaay community</p>
                            <div className='form_portion'>
                                <h4>Personal information</h4>
                                <div className='row'>
                                    <div className='w50' style={{paddingRight : "10px"}}>
                                        <Input Lable='First name' Type='text' Value={firstname} setInput = {setFirstname} />
                                    </div>
                                    <div className='w50' style={{paddingLeft : "10px"}}>
                                        <Input Lable='Last name' Type='text' Value={lastname} setInput = {setLastname} />
                                    </div>
                                </div>
                                <Input Lable='Email' Type='text' Value={email} setInput = {setEmail} />
                            </div>
                            <div className='form_portion'>
                                <h4>Create your username and password</h4>
                                <Input Lable='Username' Type='text' Value={username} setInput = {setUsername} />
                                <h6>Passwords must include a symbol or number and have at least 8 characters.</h6>
                                <div className='password_show_item'>
                                <Input Lable='Password' Type={passShow ? "text" : "password"} Value={password} setInput = {setPassword} />
                                <button onClick={()=>{setPassShow(!passShow)}}>
                                    <EyeImage width="20px" height="20px" fill = "#fff"/>
                                </button>
                                </div>
                            </div>
                        </div>

                    }
                    {page === 2 &&
                        <div className='register_form'>
                            <p>Enter account verification information</p>
                            {!contactcodesent &&
                                <>
                                <Input Lable='Contact' Type='text' Value={contact} setInput = {setContact} />
                                <BlackButton Value={"Send Code"} Action={()=>{codesend();}}/>
                                </>
                            }
                            {contactcodesent &&
                                <>
                                <Input Lable='Code' Type='text' Value={contactcode} setInput = {setContactCode} />
                                <BlackButton Value={"Verify Code"} Action={()=>{verifycode();}}/>
                                </>
                            }
                        </div>
                    }
                    <PageNav page={page} setPage={setPageCheck} add_admin={()=>{add_admin(0)}} />
                </div>
            </div>
            <p className='login_or_text'>OR</p>
            <div className='social_sign_up_container'>
                <div className='social_sign_up_item'>
                    <button onClick={googleCallBack}><ProfileIcon/></button>
                </div>
                <Facebook/>
            </div>
        </div>
    </div>
  )
}

export default Index
